import Paperbase from "./Components/Paperbase";

function App() {
  return (
    <div className="App">
      <Paperbase />
    </div>
  );
}

export default App;
